import styled from 'styled-components';

export const Container = styled.div`
  .box-header {
    .search-input {
      max-width: 200px;
    }
  }

  @media (max-width: 600px) {
    .box-header {
      flex-direction: column;

      .search-input {
        max-width: 100%;
        margin-bottom: 20px;
      }
    }
  }
`;

export const Filter = styled.div`
  margin-left: auto;
  font-size: 14px;
  color: #a7b3bb;

  @media (max-width: 600px) {
    margin-left: 0;
  }

  span {
    margin-right: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/Events/styles.js